// extracted by mini-css-extract-plugin
export default {"mobileSearchWrapper":"mobile-news-search_mobileSearchWrapper__VAShu","publishDate":"mobile-news-search_publishDate__DqZfh"};